import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = "https://api.lii.com.co:5101";

const Signup = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [familyExists, setFamilyExists] = useState(false);
  const [familyId, setFamilyId] = useState('');
  const [suggestedFamilies, setSuggestedFamilies] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const handleSignup = async () => {
    if (!firstName || !lastName || !email || !password || familyExists === null) {
      alert('Remplissez tous les champs 🙏');
      return;
    }
  
    try {
      const response = await fetch(`${API_URL}/api/auth/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ firstName, lastName, email, password, familyExists, familyId }),
      });
  
      const responseData = await response.json();
  
      console.log("📩 Réponse API après inscription :", responseData); // ✅ Vérifie ce que l'API retourne
  
      if (!response.ok) throw new Error(responseData.message || 'Inscription échouée');
  
      // ✅ Sauvegarde des infos utilisateur
      localStorage.setItem("token", responseData.token);
      localStorage.setItem("user", JSON.stringify(responseData.user));
  
      // ✅ Vérification et récupération correcte du `familyId`
      const retrievedFamilyId = responseData.familyId || responseData.user?.familyId || "ID non trouvé";
      setFamilyId(retrievedFamilyId);
  
      // ✅ Affichage de la modale avec l’ID de famille
      setShowModal(true);
  
    } catch (error) {
      console.error('Erreur Inscription:', error.message);
      setErrorMessage(error.message || 'Une erreur est survenue.');
    }
  };

  const searchFamilies = async () => {
    if (!lastName) {
      alert("Enter your last name first.");
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/family/search?lastName=${lastName}`);
      const data = await response.json();

      if (!response.ok) throw new Error(data.message || 'Search failed');
      setSuggestedFamilies(data.families);
    } catch (error) {
      console.error('Family search error:', error.message);
      setErrorMessage(error.message);
    }
  }; // ✅ Cette accolade manquait

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50">
      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-3xl font-bold text-center text-blue-600 mb-6">Inscription en 30 secondes</h2>

        {errorMessage && <p className="text-red-500 text-center mb-4">{errorMessage}</p>}

        <div className="mb-4">
          <input
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="Prénom"
          />
        </div>

        <div className="mb-4">
          <input
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="Nom"
          />
        </div>

        <div className="mb-4">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="Email"
          />
        </div>

        <div className="mb-6">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="Mot de passe"
          />
        </div>

        <div className="mb-4">
          <p className="text-gray-700 mb-2">Votre famille est elle déjà sur lii ?</p>
          <div className="flex space-x-4">
            <button
              className={`px-4 py-2 rounded-lg ${familyExists === 'true' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
              onClick={() => setFamilyExists('true')}
            >
            Oui
            </button>
            <button
              className={`px-4 py-2 rounded-lg ${familyExists === 'false' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
              onClick={() => setFamilyExists('false')}
            >
            Non
            </button>
            <button
              className={`px-4 py-2 rounded-lg ${familyExists === 'unsure' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
              onClick={() => setFamilyExists('unsure')}
            >
Je ne sais pas         </button>
          </div>
        </div>

        {familyExists === 'true' && (
          <div className="mb-4">
            <input
              type="text"
              value={familyId}
              onChange={(e) => setFamilyId(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder="Enter Family ID"
            />
          </div>
        )}

        {familyExists === 'unsure' && (
          <div className="mb-4">
            <button
              onClick={searchFamilies}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg w-full"
            >
Recherchez votre famille            </button>

            {suggestedFamilies.length > 0 && (
              <div className="mt-2 p-3 bg-gray-100 rounded-lg">
                <p className="font-semibold mb-2">Select a Family:</p>
                <ul>
                  {suggestedFamilies.map((family, index) => (
                    <li
                      key={index}
                      onClick={() => setFamilyId(family.familyId)}
                      className="p-2 bg-white shadow rounded-md cursor-pointer hover:bg-gray-200"
                    >
                      {family.familyName} ({family.familyId})
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}

        <button
          onClick={handleSignup}
          className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition duration-300"
        >
S'inscrire        </button>

        <div className="mt-4 text-center">
          <p className="text-sm text-gray-600">
           Vous avez déjà un compte ?{' '}
            <a href="/login" className="text-blue-600 hover:underline">Se connecter</a>
          </p>
        </div>
      </div>

      {/* ✅ Modale affichant l’ID de famille après inscription */}
{showModal && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded-lg shadow-lg text-center">
      <h2 className="text-2xl font-bold text-orange-600">Votre ID de famille</h2>
      <p className="text-gray-700 mt-2">Partagez cet identifiant avec votre famille pour qu'ils puissent rejoindre votre espace.</p>
      <div className="flex justify-between items-center bg-gray-100 p-3 rounded-lg mt-4">
        <span className="text-lg font-semibold">{familyId}</span>
        <button onClick={() => { navigator.clipboard.writeText(familyId); alert("ID copié !"); }}
          className="bg-orange-500 text-white px-3 py-1 rounded-md">
          📋 Copier
        </button>
      </div>
      <button onClick={() => { setShowModal(false); navigate('/'); }}
        className="mt-4 bg-gray-600 text-white px-4 py-2 rounded-lg">
        Fermer
      </button>
    </div>
  </div>
)}
    </div>
  );
};



export default Signup;